<template>
    <div id="mainPDF">
        <div class="head">
            <div class="logo">
                <img src="../assets/images/logo.png" alt />
            </div>
            <div class="title">
                <p class="num">Undertaking by the driver</p>
                <p class="detail">
                    <span style="padding: 0 8px; font-weight: bold">{{
                        new Date() | moment("DD/MM/YYYY")
                    }}</span>
                </p>
            </div>
        </div>
        <div class="body">
            <div class="address">
                <h4 class="name">All shipment</h4>
            </div>

            <div class="table">
                <table>
                    <thead>
                        <tr>
                            <th style="text-align: left !important">
                                Tracking number
                            </th>
                            <th style="text-align: left !important">Date</th>
                            <th style="text-align: left !important">Weight</th>
                            <th style="text-align: left !important">Pieces</th>
                            <th style="text-align: left !important">
                                contents
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, i) in checkedRows" :key="i">
                            <td
                                style="
                                    font-weight: bold;
                                    text-align: left !important;
                                "
                            >
                                {{ item.vendor_shipment_id || "-" }}
                            </td>
                            <td style="text-align: left !important">
                                {{ item.created_at | moment("DD/MM/YYYY") }}
                            </td>
                            <td style="text-align: left !important">
                                {{ item.total_weight }} KG
                            </td>
                            <td style="text-align: left !important">
                                {{
                                    item.packages.reduce((a, b) => {
                                        return a + b.quantity;
                                    }, 0)
                                }}
                            </td>
                            <td style="text-align: left !important">
                                <template v-for="(content, i) in item.contents">
                                    {{ content.title }}
                                    {{
                                        i != item.contents.length - 1
                                            ? ", "
                                            : ""
                                    }}
                                </template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="footer">
            <div class="content">
                <h3 class="text">
                    I pledge, I am -------------, with plate number
                    --------------, that I have picked up the shipment with the
                    above details, and i will take full responsibility in case
                    of any missing from my side.
                </h3>

                <div class="signature">
                    <p>Driver's signature</p>
                    <p>---------------</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["checkedRows"],
};
</script>

<style lang="scss">
@page {
    size: A4;
    margin: 10px 0;
    -webkit-print-color-adjust: exact;
}

@media print {
    .page-break {
        display: block;
        page-break-before: always;
    }

    body {
        margin: 0;
        padding: 0;
    }

    #mainPDF {
        -webkit-print-color-adjust: exact;
        margin: 0;
        padding: 0;

        // position: absolute;
        // top: 0;
        // left: 0;
        // right: 0;
        // padding: 0;
        // margin: 0;
        .head {
            direction: ltr;
            border-bottom: 1px solid #ddd;
            padding: 10px 20px;

            .logo {
                margin: 5px 7px;

                img {
                    width: 150px;
                    opacity: 0.5;
                }
            }

            .title {
                p {
                    padding: 5px 20px;

                    &.num {
                        font-size: 20px;
                        margin-bottom: 0;
                        color: #777;
                    }

                    &.detail {
                        opacity: 0.9;
                        font-size: 16px;
                        font-weight: bold;
                        background: #ddd;
                        display: inline-block;
                        padding: 5px 30px;
                        margin: 0 20px;
                        border-radius: 50px;
                    }
                }
            }
        }

        .body {
            padding: 5px 40px;

            .address {
                direction: ltr;

                .name {
                    font-size: 24px;
                    margin: 10px 0;
                }
            }

            .table {
                margin-top: 20px;
                padding: 0;

                table {
                    direction: ltr;

                    th {
                        text-align: left !important;
                    }

                    tbody {
                        tr {
                            direction: ltr;

                            td {
                                text-align: left !important;
                                font-size: 16px;

                                .button {
                                    display: none;
                                }
                            }
                        }
                    }

                    .total {
                        font-weight: bold;
                        text-align: center;
                    }

                    .primary {
                        color: #4952ff;
                        font-weight: bold;
                        color: white;
                    }

                    .danger {
                        color: #ff7977;
                        font-weight: bold;
                    }
                }
            }
        }

        .footer {
            direction: ltr;
            border-top: none;
            margin-top: 30px;
            padding-top: 30px;
            width: 100%;
            position: fixed;
            bottom: 0;
            left: 0;

            .content {
                .text {
                    font-size: 18px;
                    font-weight: bold;
                    color: #777;
                }

                .signature {
                    margin-top: 30px;
                }
            }
        }
    }
}

.options {
    text-align: right;
    padding: 0 28px 0;

    .button {
        margin: 0 15px 40px;
        background: none;
        color: black;
        height: 30px;
        font-size: 14px;
        border-color: #777 !important;
    }
}
</style>
